"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationTotalCount = exports.LastPageIcon = exports.NextPageIcon = exports.PreviousPageIcon = exports.FirstPageIcon = exports.PageIcon = exports.PageIconWrapper = exports.PageButton = exports.PageButtonListItem = exports.PageButtonList = exports.Pagination = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const button_1 = __importDefault(require("@kyruus/button"));
const DoubleArrowLeft_1 = __importDefault(require("@kyruus/react-ikons/DoubleArrowLeft"));
const ArrowLeft_1 = __importDefault(require("@kyruus/react-ikons/ArrowLeft"));
const DoubleArrowRight_1 = __importDefault(require("@kyruus/react-ikons/DoubleArrowRight"));
const ArrowRight_1 = __importDefault(require("@kyruus/react-ikons/ArrowRight"));
exports.Pagination = (0, styled_1.default)('nav') `
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1em;
  padding-top: 0.5em;
`;
exports.PageButtonList = (0, styled_1.default)('ul') `
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
`;
exports.PageButtonListItem = (0, styled_1.default)('li') `
  margin: 0;
  &:first-of-type > button {
    margin-left: 0;
    border-bottom-left-radius: ${(0, ui_theme_1.fromTheme)('border_radius')};
    border-top-left-radius: ${(0, ui_theme_1.fromTheme)('border_radius')};
  }
  &:last-of-type > button {
    border-bottom-right-radius: ${(0, ui_theme_1.fromTheme)('border_radius')};
    border-top-right-radius: ${(0, ui_theme_1.fromTheme)('border_radius')};
  }
`;
exports.PageButton = (0, styled_1.default)(button_1.default) `
  display: flex;
  border-radius: 0;
  line-height: 1.43;
  text-decoration: none;
  margin-left: -1px;
  ${({ onClick }) => onClick ? 'cursor: pointer;' : 'cursor: default; pointer-events: none;'};
  &:not([aria-current='page']):not(:disabled) {
    background-color: ${(0, ui_theme_1.fromTheme)('color_background')};
    color: ${(0, ui_theme_1.fromTheme)('color_link')};
  }
`;
exports.PageIconWrapper = (0, styled_1.default)('span') `
  position: relative;
  min-height: ${(0, ui_theme_1.fromTheme)('font_line_height')}em;
  width: 0;
`;
exports.PageIcon = (0, styled_1.default)('svg') `
  position: absolute;
  right: -0.8em;
  top: -0.2em;
  margin-top: 1px;
`;
exports.FirstPageIcon = (0, styled_1.default)(exports.PageIcon) `
  right: -0.6em;
  top: 0.2em;
`.withComponent(DoubleArrowLeft_1.default);
exports.PreviousPageIcon = exports.PageIcon.withComponent(ArrowLeft_1.default);
exports.NextPageIcon = exports.PageIcon.withComponent(ArrowRight_1.default);
exports.LastPageIcon = (0, styled_1.default)(exports.PageIcon) `
  right: -0.6em;
  top: 0.2em;
`.withComponent(DoubleArrowRight_1.default);
exports.PaginationTotalCount = styled_1.default.div `
  display: inline-block;
  padding-left: 15px;
  font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
`;
//# sourceMappingURL=Paginator.styles.js.map